import { CampaignType } from '../../../../constants/marketingCampaign'
import { BuildFormValuesContext } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { ProductDiscountThresholdRuleState } from './types'

export function buildProductDiscountThresholdFormValues(
	ctx: BuildFormValuesContext<ProductDiscountThresholdRuleState>,
): Record<string, unknown> {
	const { rule, confirmation, selectedShopIds, campaignMeta, marketingCampaignKey } = ctx
	const base: Record<string, unknown> = {
		startDate: confirmation.startDate,
		startTime: confirmation.startTime,
		discount: rule.discount,
		threshold: rule.threshold,
		type: CampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD,
		shopIds: selectedShopIds,
		valueType: campaignMeta.valueType,
		products: rule.products,
		hasLimit: true,
		limit: confirmation.limit,
		marketingCampaignKey,
		orderTypes: confirmation.orderTypes,
		isPermanent: confirmation.isPermanent,
	}

	if (!confirmation.isPermanent) {
		base.endDate = confirmation.endDate
		base.endTime = confirmation.endTime
	}

	return base
}
